import React, { lazy } from 'react'
import type { RouteObject } from 'react-router'

const MyAccount = lazy(() => import('./MyAccount'))

const routes: RouteObject[] = [
    {
        path: '/my-account/profile',
        element: <MyAccount />
    }
]

export default routes
